import * as React from "react";
import { GameToken } from "./Card";
import {DeckComponent} from "./DeckComponent";
import {IInvestigatorInPlay} from "./Scenario";

export interface IInvestigatorCardProps {
    investigator: IInvestigatorInPlay;
    onChanged: () => void;
}
export class InvestigatorCardComponent extends React.Component<IInvestigatorCardProps, any> {
    render() {
        const deck = { cards: [this.props.investigator.card] };
        const cssClasses = "investigator-card";
        return (
            
            <div className={cssClasses}>
                <DeckComponent horizontal={true} deck={deck}
                    settings={{
                        allowedTokens: [GameToken.Clue, GameToken.Health, GameToken.Resource, GameToken.Sanity,GameToken.Action],
                        hideTokensOnBack: true,
                        toolbar: { actions: [
                            {
                                title: "Resign",
                                action: () => { if (window.confirm("Are you sure you would like to resign the investigator?")
                                ) {
                                    this.props.investigator.resigned = true;
                                    this.props.onChanged();
                                }
                                },
                                minNoOfCards:1,
                                icon:"glyphicon glyphicon-off"
                            }]
                        }
                    }}
                    onChanged={() => this.props.onChanged()} />
            </div>
        );
    }
}
